import React from 'react';

/** Page title block for Q Value (QC) list pages — matches Planning MRP layout. */
export default function QValuePageHeader({ title, subtitle }) {
    if (!title) {
        return null;
    }

    return (
        <div style={{ marginTop: '20px', marginBottom: '16px' }}>
            <h4>{title}</h4>
            {subtitle ? <p className="text-muted">{subtitle}</p> : null}
        </div>
    );
}
